module.exports = __webpack_public_path__ + "img/home-pocket_cn.174f095.jpg";